<div id="preloader">
	<div class="jumper">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>  
<!-- ***** Preloader End ***** -->

<!-- Header removed: global header is now provided by <app-header> -->

<div class="container row">

	<div class="col-md-12">

		<h1>Upload Image</h1>

	</div>

</div>

<div class="container row">

	<div class="col-md-6">

		<input type="file" (change)="onFileChanged($event)">

	</div>
	<div class="col-md-6">

		<input type="button" (click)="onUpload()" value="upload">

	</div>

</div>

<hr />

<div class="container row">

	<div class="col-md-12">

		<div *ngIf=msg>{{msg}}</div>
	</div>

</div>


<div class="container row">

	<div class="col-md-6">

		<input type="text" class="form-control" id="name"
			placeholder="image name" name="name" [(ngModel)]="imagemodel.imageName"  />
	</div>

	<div class="col-md-6">

		<input type="button" (click)="getImage()" value="Get Image">

	</div>

</div>


<div class="container row">

	<div class="col-md-12">

		<div *ngIf=imagemodel.retrievedImage>

			<img [src]="imagemodel.retrievedImage">

		</div>

	</div>

</div>

